import * as diacritics from "diacritics"
import { DeliveryProvider } from "../models/restaurant"

export const capitalize = (s: string) => s.charAt(0).toUpperCase() + s.slice(1)

export const sanitizeString = (string: string) => {
  return diacritics.remove(string.toLowerCase().replace(/\s/g, ""))
}

export const isBuzzRiders = (provider: DeliveryProvider | null) => {
  return provider === "rider"
}

export const shouldUseCustomAsapText =
  !!process.env.GATSBY_CUSTOM_ASAP_TEXT_LOCALICE_KEY

export const setHTMLTagLang = (lang: string) => {
  document.documentElement.setAttribute("lang", lang)
}
